module.exports = __webpack_public_path__ + "img/like.57de3977.png";